<style src="./OptionMenu.scss" lang="scss"></style>
<template>
  <div class="context-menu" @click.stop>
    <div class="loading" v-if="isLoading"></div>
    <ul class="list">
      <li class="item" v-if="eventStatus !== 3">
        <div class="description">
          <span class="title">
            Suspender sem data
          </span>
          <span class="description">
            O evento será suspenso para uma posterior reabertura mas nenhuma data prévia foi informada até o momento
          </span>
        </div>
        <div class="command">
          <button
          @click="suspendNoDate"
          class="button-action">
          Suspender
          </button>
        </div>
      </li>
      <li class="item" v-if="eventStatus === 3">
        <div class="description">
          <span class="title">
            Desfazer suspensão
          </span>
          <span class="description">
            Será removido o atual status de suspenso permitindo que o evento possa seguir sendo processado.
          </span>
        </div>
        <div class="command">
          <button
          @click="removeSuspendNoDate"
          class="button-action">
          Desfazer
          </button>
        </div>
      </li>
      <li class="item">
        <div class="description">
          <span class="title">
            Reagendar evento
          </span>
          <span class="description">
            A etapa de lances ocorrerá na nova data à ser preenchida
          </span>

          <div class="form">
            <datebox
              class="input"
              label="Data de reabertura"
              placeholder="30/12/2020"
              v-model="reopenDate" />
            <textbox
              class="input"
              label="Hora de reabertura"
              placeholder="13:30"
              v-model="reopenTime" />
          </div>
        </div>
        <div class="command">
          <button
          @click="suspendUntil"
          class="button-action">
          Reagendar
          </button>
        </div>
      </li>
      <li class="item">
        <div class="description">
          <span class="title danger">
            Cancelar o evento
          </span>
          <span class="description">
            Ao cancelar um evento, nenhuma interação poderá ser feita.
          </span>
        </div>
        <div class="command">
          <button
          @click="cancelEvent"
          class="button-action button-action__danger">
          Cancelar
          </button>
        </div>
      </li>
      <!-- <li class="item">
        <div class="description">
          <span class="title danger">
            Reabrir evento
          </span>
          <span class="description">
            Para retornar um evento cancelado utilize o esse comando
          </span>
        </div>
        <div class="command">
          <button
          @click="cancelEvent"
          class="button-action">
          Reabrir
          </button>
        </div>
      </li> -->
    </ul>
  </div>
</template>

<script>
import { IconUser } from '@/components/primitives/icons'
import { Datebox, Textbox } from '@/components/primitives'
import moment from 'moment'

export default {
  name: 'OptionMenu',
  components: {
    IconUser,
    Datebox,
    Textbox
  },
  props: {
    eventId: {
      default: null
    },
    eventStatus: {
      default: 1
    }
  },
  data () {
    return {
      isLoading: false,
      reopenDate: '',
      reopenTime: ''
    }
  },
  methods: {
    async suspendNoDate () {
      this.isLoading = true
      await this.$store.dispatch('Board/SET_WAIT_WITHOUT_DATE', {
        eventId: this.eventId
      })
      this.$store.commit('Board/SET_FILTER', { refreshAt: new Date() })
      this.isLoading = false
      this.$emit('close')
    },
    async removeSuspendNoDate () {
      this.isLoading = true
      await this.$store.dispatch('Board/SET_REMOVE_WAIT_WITHOUT_DATE', {
        eventId: this.eventId,
        removeSuspend: true
      })
      this.$store.commit('Board/SET_FILTER', { refreshAt: new Date() })
      this.isLoading = false
      this.$emit('close')
    },
    suspendUntil () {
      if (!this.reopenDate) {
        this.$toast.error('É necessário informar uma data')
        return
      }

      const date = moment(`${this.reopenDate} ${this.reopenTime}:00`, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      this.$store.dispatch('Board/SET_WAIT_NEW_DATE', {
        eventId: this.eventId,
        date
      })
      this.$emit('close')
    },
    async cancelEvent () {
      this.isLoading = true
      await this.$store.dispatch('Board/CANCEL_EVENT', {
        eventId: this.eventId
      })
      this.isLoading = false
      this.$emit('close')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/board/components/option-menu/OptionMenu.vue